import * as React from 'react';

import { cn } from '../../lib/utils';

interface JourneyCanvasProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export function JourneyCanvas({
  children,
  className,
  ...props
}: JourneyCanvasProps) {
  return (
    <main className="relative min-h-screen overflow-hidden bg-[#f7f2ea] px-4 py-4 text-[#16323b] sm:px-6 lg:px-8">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(15,118,110,0.14),transparent_34%),radial-gradient(circle_at_88%_10%,rgba(245,158,11,0.16),transparent_28%),radial-gradient(circle_at_50%_100%,rgba(239,125,87,0.16),transparent_32%),linear-gradient(180deg,#faf5ee_0%,#f6efe4_100%)]" />
      <div className="pointer-events-none absolute inset-0 opacity-50 [background-image:linear-gradient(rgba(255,255,255,0.75)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.65)_1px,transparent_1px)] [background-size:96px_96px]" />
      <div className="pointer-events-none absolute -left-20 top-20 h-72 w-72 rounded-full bg-[#0f766e]/15 blur-3xl" />
      <div className="pointer-events-none absolute right-[-4rem] top-[-2rem] h-96 w-96 rounded-full bg-[#f5b25f]/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-[-8rem] left-1/3 h-80 w-80 rounded-full bg-[#ef7d57]/12 blur-3xl" />

      <div className={cn('relative mx-auto max-w-7xl', className)} {...props}>
        {children}
      </div>
    </main>
  );
}
